export function newId(prefix = ''): string {
  const bytes = new Uint8Array(12);
  crypto.getRandomValues(bytes);
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  return prefix ? `${prefix}_${hex}` : hex;
}

/** Stable non-cryptographic hash, used to pick deterministic voices per character. */
export function hashString(value: string, basis = 2166136261): number {
  let hash = basis;
  for (let i = 0; i < value.length; i += 1) {
    hash ^= value.charCodeAt(i);
    hash = Math.imul(hash, 16777619);
  }
  return hash >>> 0;
}

const SEPARATOR = '\u0000';

/**
 * Content-derived id, stable across re-imports of the same script.
 *
 * Two independent 32-bit hashes are concatenated for a 64-bit id space, which
 * makes accidental collisions negligible at realistic script sizes.
 */
export function stableId(prefix: string, ...parts: string[]): string {
  const input = parts.join(SEPARATOR);
  const high = hashString(input, 2166136261).toString(16).padStart(8, '0');
  const low = hashString(input, 2246822519).toString(16).padStart(8, '0');
  return `${prefix}_${high}${low}`;
}

/**
 * Normalized form used for id derivation. Ignores case, punctuation and
 * whitespace so the same line exported from PDF, DOCX or TXT — which differ in
 * quote characters and line wrapping — still yields one id.
 */
export function contentKey(value: string): string {
  return value
    .toLowerCase()
    .replace(/[\u2018\u2019]/g, "'")
    .replace(/[\u201C\u201D]/g, '"')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();
}
